<app-draggable-modal-wrapper>
    <h2
        mat-dialog-title
        modal-drag-handle
        class="!text-2xl !font-normal !text-primary-700 !mb-2"
    >
        Billing Information
    </h2>
    <hr />
    <mat-dialog-content class="ps-6 pt-2 mat-typography">
        <form [formGroup]="form">
            <div class="flex flex-col gap-2 w-full">
                <mat-form-field appearance="outline" class="w-full">
                    <mat-label>Bill To Organization Name</mat-label>
                    <input
                        title="Bill To Organization Name"
                        matInput
                        [formControl]="form.controls.organizationName"
                        [appRegexInput]="
                            regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                        "
                        maxlength="128"
                    />
                </mat-form-field>
                <mat-form-field appearance="outline" class="w-full">
                    <mat-label>Contact Name</mat-label>
                    <input
                        title="Contact Name"
                        matInput
                        [formControl]="form.controls.contactName"
                        [appRegexInput]="
                            regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                        "
                        maxlength="96"
                    />
                </mat-form-field>
                <mat-form-field appearance="outline" class="w-full">
                    <mat-label>Street Address</mat-label>
                    <input
                        title="Street Address"
                        matInput
                        [formControl]="form.controls.primaryStreetAddress"
                        [appRegexInput]="
                            regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                        "
                        maxlength="96"
                    />
                </mat-form-field>
                <mat-form-field appearance="outline" class="w-full">
                    <mat-label>Street Address 2</mat-label>
                    <input
                        title="Street Address 2"
                        matInput
                        [formControl]="form.controls.secondaryStreetAddress"
                        [appRegexInput]="
                            regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                        "
                        maxlength="96"
                    />
                </mat-form-field>
                <div class="flex flex-row gap-2">
                    <mat-form-field appearance="outline" class="w-1/2">
                        <mat-label>City</mat-label>
                        <input
                            title="City"
                            matInput
                            [formControl]="form.controls.city"
                            [appRegexInput]="
                                regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                            "
                            maxlength="64"
                        />
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="w-1/4">
                        <mat-label>State</mat-label>
                        <mat-select [formControl]="form.controls.state">
                            @for (
                                stateCode of stateCodeOptions;
                                track stateCode.value
                            ) {
                                <mat-option [value]="stateCode.value">{{
                                    stateCode.label
                                }}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="w-1/4">
                        <mat-label>Zip Code</mat-label>
                        <input
                            title="Zip Code"
                            matInput
                            [formControl]="form.controls.zipCode"
                            [imask]="maskOptions.postalCode"
                            [unmask]="true"
                            [pattern]="regExPattern.PostalCode"
                        />
                    </mat-form-field>
                </div>
                <mat-form-field appearance="outline" class="w-full">
                    <mat-label>Email</mat-label>
                    <input
                        title="Email"
                        matInput
                        [formControl]="form.controls.contactEmail"
                        [pattern]="regExPattern.EmailAddress"
                    />
                </mat-form-field>
            </div>
        </form>
    </mat-dialog-content>
    <mat-dialog-actions align="end" class="!p-5">
        <button
            type="button"
            mat-stroked-button
            color="primary"
            class="!border-primary-700"
            (click)="onCancel()"
        >
            Cancel
        </button>
        <button
            mat-raised-button
            type="button"
            name="Save"
            cdkFocusInitial
            color="primary"
            [disabled]="!isFormValid"
            (click)="onSave()"
        >
            Save
        </button>
    </mat-dialog-actions>
</app-draggable-modal-wrapper>
